var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyFileIndicator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 292.987,
    height: 319.781,
    viewBox: "0 0 292.987 319.781",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard_18_copy_4",
    "data-name": "Artboard 18 copy 4",
    transform: "translate(-41.954 -41.76)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_644",
    "data-name": "Rectangle 644",
    width: 217.548,
    height: 264.827,
    transform: "matrix(0.962, -0.272, 0.272, 0.962, 41.954, 106.669)",
    fill: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4127",
    "data-name": "Path 4127",
    d: "M301.43,41.76H148.28v267.4H354.922V96.454L301.438,41.76Z",
    transform: "translate(-19.981)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4128",
    "data-name": "Path 4128",
    d: "M332.43,58.64v59.98l56.756-18.995-49.61,2.842Z",
    transform: "translate(-54.587 -3.172)",
    fill: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_645",
    "data-name": "Rectangle 645",
    width: 77.797,
    height: 16.404,
    transform: "translate(159.296 235.327)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_646",
    "data-name": "Rectangle 646",
    width: 113.041,
    height: 16.412,
    transform: "translate(159.296 204.947)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_647",
    "data-name": "Rectangle 647",
    width: 113.041,
    height: 16.42,
    transform: "translate(159.296 171.205)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyFileIndicator);
export default __webpack_public_path__ + "static/media/EmptyFileIndicator.bb9ba2eea1f8c42eaa6642a99155e66e.svg";
export { ForwardRef as ReactComponent };